"use client";

import { LocaleProvider } from "@/i18n/provider";

/**
 * Force every `useT()` / `useLocale()` call in this subtree to resolve
 * to English, regardless of the visitor's stored / browser preference.
 *
 * Use this on the public marketing surface (`/`, `/demo`, `/contact`,
 * `/signup`, `/login`). The marketing site mixes hardcoded
 * English copy with i18n'd nav / form labels — without this scope a
 * Dutch-browser visitor sees a header in Dutch and a body in English,
 * which is the exact bug the user reported in 2026-05.
 *
 * The dashboard (post-login) keeps its own LocaleProvider at the root
 * layout, so authenticated users still get their preferred language.
 */
export function EnglishMarketingScope({ children }: { children: React.ReactNode }) {
  // resolveOnMount={false} is the load-bearing flag: without it, the
  // provider would re-resolve to the visitor's stored locale right after
  // mount and undo the lock.
  return (
    <LocaleProvider initialLocale="en" resolveOnMount={false}>
      {children}
    </LocaleProvider>
  );
}
